import { defineStyle } from '@chakra-ui/react';

export const toggleVariant = defineStyle({
  cursor: 'pointer',
  border: '2px solid',
  backgroundColor: 'neutral.800',
  borderColor: 'neutral.600 !important',
  boxSizing: 'border-box',
  _icon: {
    color: 'neutral.300',
  },
  '&[data-active="true"]': {
    backgroundColor: 'blue.700',
    borderColor: 'blue.500 !important',
  },
  _disabled: {
    opacity: 0.5,
  },
  _hover: {
    borderColor: 'skyBlue !important',
    _icon: {
      '&:not([data-custom-color])': {
        color: 'skyBlue !important',
      },
    },
  },
  '&[data-half-active=true]': {
    _before: {
      content: '""',
      position: 'absolute',
      right: 2,
      boxSize: '8px',
      backgroundColor: 'blue.500',
      borderRadius: 'none',
    },
  },
});
